module.exports = __webpack_public_path__ + "img/2.a21a3c25.jpg";